// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button.close[data-v-e9647040]{color:#000!important}.form-group label[data-v-e9647040]{font-weight:700}.tooltip-btn[data-v-e9647040]{width:25px;height:25px;border:0;border-radius:4px;margin-left:4px;background-color:#3c4b64;color:#fff}.tooltip-btn[data-v-e9647040]:hover{cursor:pointer}", ""]);
// Exports
module.exports = exports;
